var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M64.654,14.951H25.345c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h39.309c1.657,0,3,1.343,3,3 C67.654,13.608,66.312,14.951,64.654,14.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M87,31.837H3c-1.657,0-3-1.343-3-3v-8.87C0,13.893,4.942,8.951,11.016,8.951h6.398c1.657,0,3,1.343,3,3 c0,1.657-1.343,3-3,3h-6.398C8.25,14.951,6,17.201,6,19.967v5.87h78v-5.87c0-2.766-2.25-5.017-5.017-5.017h-6.397 c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h6.397C85.058,8.951,90,13.893,90,19.967v8.87C90,30.494,88.657,31.837,87,31.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M78.983,89.123H11.016C4.942,89.123,0,84.181,0,78.106V28.837c0-1.657,1.343-3,3-3h84c1.657,0,3,1.343,3,3 v49.269C90,84.181,85.058,89.123,78.983,89.123z M6,31.837v46.269c0,2.767,2.25,5.017,5.016,5.017h67.967 c2.767,0,5.017-2.25,5.017-5.017V31.837H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M23.761,51.483h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C26.372,50.313,25.203,51.483,23.761,51.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M47.381,51.483h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C49.993,50.313,48.824,51.483,47.381,51.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M71.001,51.483h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C73.613,50.313,72.444,51.483,71.001,51.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M23.761,72.022h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C26.372,70.853,25.203,72.022,23.761,72.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M47.381,72.022h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C49.993,70.853,48.824,72.022,47.381,72.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M71.001,72.022h-4.762c-1.442,0-2.612-1.169-2.612-2.612v-4.762c0-1.442,1.169-2.612,2.612-2.612h4.762 c1.442,0,2.612,1.169,2.612,2.612v4.762C73.613,70.853,72.444,72.022,71.001,72.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M22.734,20.025h-2.708c-1.442,0-2.612-1.169-2.612-2.612V6.489c0-1.442,1.169-2.612,2.612-2.612h2.708 c1.442,0,2.612,1.169,2.612,2.612v10.924C25.345,18.855,24.176,20.025,22.734,20.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M69.975,20.025h-2.708c-1.442,0-2.612-1.169-2.612-2.612V6.489c0-1.442,1.169-2.612,2.612-2.612h2.708 c1.442,0,2.612,1.169,2.612,2.612v10.924C72.586,18.855,71.417,20.025,69.975,20.025z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.c76aa7c4aaeb4d85cb2dd2af02085b55.svg";
export { ForwardRef as ReactComponent };